import Messages, {Message} from './Messages'

export const messageStore = new Messages();
let id = 0;
export const autoId = () => {
  id +=1;
  return id;
};

const unToast = id => {
  messageStore.remove({id})
};

export const msgTimeout = (messageDisplayTimeMillis, realId) => {
  if(messageDisplayTimeMillis === 0){
    return;
  }
  return setTimeout(() => {
    unToast(realId);
  }, messageDisplayTimeMillis);
};

export const toast = (config) => ({id, message, params, type}) => {
  let {messageDisplayTimeMillis} = config;
  let realId = id || autoId();
  let realType = type || 'info';
  let timeout = msgTimeout(messageDisplayTimeMillis, realId);
  let existing = messageStore.messages.find(it => (it.id === realId));
  let msg = new Message(realId, realType, message, params, timeout);
  if(existing){
    existing.clearTimeout();
    messageStore.replace(msg);
  } else {
    messageStore.add(msg);
  }
};
